import * as React from 'react';
const CSVIcon = ({ size = '18px', fill = '#738DA6', currentColor, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M15.29 1H3v11h1V2h10v6h6v14H4v-3H3v4h18V6.709zM20 7h-5V2h.2L20 6.8zm-4.96 11 2.126-5H16.08l-1.568 3.688L12.966 13h-1.084l2.095 5zM7 14.349v.302A1.35 1.35 0 0 0 8.349 16H9.65a.35.35 0 0 1 .349.349v.302A.35.35 0 0 1 9.65 17H7v1h2.651A1.35 1.35 0 0 0 11 16.651v-.302A1.35 1.35 0 0 0 9.651 15H8.35a.35.35 0 0 1-.35-.349v-.302A.35.35 0 0 1 8.349 14H11v-1H8.349A1.35 1.35 0 0 0 7 14.349m-5 .692v.918A2.044 2.044 0 0 0 4.041 18H6v-1H4.041A1.04 1.04 0 0 1 3 15.959v-.918A1.04 1.04 0 0 1 4.041 14H6v-1H4.041A2.044 2.044 0 0 0 2 15.041'
            fill={currentColor ? 'currentColor' : fill}
        />
        <path fill='none' d='M0 0h24v24H0z' />
    </svg>
);
export default CSVIcon;
